import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Flex } from 'roo-ui/components';

const GridDataRow = styled(Flex)`
  width: 100%;
  flex-wrap: wrap;

  ${themeGet('mediaQueries.0')} {
    &:not(:last-child) {
      border-bottom: ${themeGet('borders.1')} ${themeGet('colors.greys.alto')};
    }
  }
`;

GridDataRow.displayName = 'GridDataRow';

export default GridDataRow;
